import React, { useState, useEffect } from 'react';
import Layout from '../components/common/Layout';
import { ajustesService } from '../services/ajustes';
import toast from 'react-hot-toast';
import { Settings, Mail, Save, Loader2 } from 'lucide-react';

const FilaNotificacion = ({ item, onGuardar }) => {
    const [destinatarios, setDestinatarios] = useState((item.destinatarios || '').split(',').map((e) => e.trim()).filter(Boolean).join(', '));
    const [frecuencia, setFrecuencia] = useState(item.frecuencia || 'mensual');
    const [activo, setActivo] = useState(item.activo !== false);
    const [guardando, setGuardando] = useState(false);

    const hayCambios =
        destinatarios !== (item.destinatarios || '').split(',').map((e) => e.trim()).filter(Boolean).join(', ') ||
        frecuencia !== item.frecuencia ||
        activo !== (item.activo !== false);

    const handleGuardar = async () => {
        setGuardando(true);
        try {
            const lista = destinatarios.split(',').map((e) => e.trim()).filter(Boolean);
            await onGuardar(item.modulo, { destinatarios: lista, frecuencia, activo });
            toast.success(`Ajustes de "${item.nombre}" guardados`);
        } catch (error) {
            toast.error(error?.response?.data?.detail || 'Error al guardar');
        } finally {
            setGuardando(false);
        }
    };

    return (
        <tr className="border-b border-gray-100">
            <td className="px-4 py-3 text-sm font-medium text-gray-800 whitespace-nowrap">{item.nombre}</td>
            <td className="px-4 py-3">
                <input
                    type="text"
                    value={destinatarios}
                    onChange={(e) => setDestinatarios(e.target.value)}
                    placeholder="correo1@empresa.com, correo2@empresa.com"
                    className="w-full px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
            </td>
            <td className="px-4 py-3">
                <select
                    value={frecuencia}
                    onChange={(e) => setFrecuencia(e.target.value)}
                    className="px-2 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="mensual">Mensual</option>
                    <option value="quincenal">Quincenal</option>
                </select>
            </td>
            <td className="px-4 py-3 text-center">
                <input
                    type="checkbox"
                    checked={activo}
                    onChange={(e) => setActivo(e.target.checked)}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
            </td>
            <td className="px-4 py-3 text-right">
                <button
                    onClick={handleGuardar}
                    disabled={!hayCambios || guardando}
                    className="flex items-center px-3 py-1.5 bg-blue-600 text-white text-xs font-semibold rounded-lg hover:bg-blue-700 disabled:opacity-40 transition-colors ml-auto"
                >
                    {guardando ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-1" />}
                    Guardar
                </button>
            </td>
        </tr>
    );
};

const AjustesPage = () => {
    const [items, setItems] = useState([]);
    const [cargando, setCargando] = useState(false);

    const cargar = async () => {
        setCargando(true);
        try {
            const data = await ajustesService.listarNotificaciones();
            setItems(data);
        } catch {
            toast.error('Error al cargar los ajustes de notificación');
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => { cargar(); }, []);

    const handleGuardar = async (modulo, datos) => {
        const actualizado = await ajustesService.actualizarNotificacion(modulo, datos);
        setItems((prev) => prev.map((it) => (it.modulo === modulo ? actualizado : it)));
    };

    return (
        <Layout>
            <div className="p-6">
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                        <Settings className="h-7 w-7 text-blue-600" />
                        Ajustes
                    </h1>
                    <p className="text-gray-500 text-sm mt-1">
                        Configura a quién avisar y con qué frecuencia, por cada módulo de inspección.
                    </p>
                </div>

                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
                    <h2 className="text-base font-semibold text-gray-700 mb-1 flex items-center gap-2">
                        <Mail className="h-5 w-5 text-blue-500" />
                        Aviso de llenado de inspecciones
                    </h2>
                    <p className="text-xs text-gray-500 mb-4">
                        Mensual: se envía el día 1 de cada mes. Quincenal: se envía los días 1 y 16.
                    </p>

                    {cargando ? (
                        <div className="flex justify-center py-10">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
                        </div>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="min-w-full">
                                <thead>
                                    <tr className="border-b border-gray-200 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                        <th className="px-4 py-2">Módulo</th>
                                        <th className="px-4 py-2">Destinatarios (separados por coma)</th>
                                        <th className="px-4 py-2">Frecuencia</th>
                                        <th className="px-4 py-2 text-center">Activo</th>
                                        <th className="px-4 py-2"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item) => (
                                        <FilaNotificacion key={item.modulo} item={item} onGuardar={handleGuardar} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
};

export default AjustesPage;
